<template>
    <div class="summary">
        <div class="first" v-if="firstTransaction">{{ $t('Home.dashboard.overview.initialPosition') }}</div>
        <div class="total" v-else>
            <div class="shareCount">{{ postTransactionStockShareCount }}</div>
            <div class="shareTotal">{{ postTransactionStockMarketValue }}</div>
        </div>
    </div>
</template>

<script>
import StockHtmlHelper from '../stocks/StockHtmlHelper';

export default {
    props: {
        entry: Object
    },
    created() {
        this.stockHTMLHelper = new StockHtmlHelper()
    },
    computed: {
        firstTransaction() {
            return this.entry.postTransactionStockShareCount === this.entry.shareCount
        },
        postTransactionStockShareCount() {
            return this.entry.postTransactionStockShareCount
        },
        postTransactionStockMarketValue() {
            return this.stockHTMLHelper.formatLocalNumber(this.entry.postTransactionStockMarketValue, this.$i18n.locale)
        }
    }
}
</script>

<style lang="scss" scoped>
.summary {
    padding-top: 5px;
    border-top: solid 1px var(--darkBG);
    .total {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 0.75em;
        gap: 5px;
        .shareCount {
        }
        .shareTotal {
            font-weight: bold;
        }
    }
}
</style>